import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BaseChipListSelectSearch as MainBase } from '../../form-kit/chip-list-select-search/base/base-chip-list-select-search.component';

@Component({
    template: '',
    imports: [
        CommonModule
    ]
})
export abstract class BaseChipListSelectSearch extends MainBase {
}
